import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import PageTitle from "@components/Common/PageTitle";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import CardMenu from "./CardMenu";
import { CARD_MENU_LIST } from "./CardMenuList";

import { store as userStore } from "@components/VerticalLayout/store";
import "../Home/Cartestyle.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export function ScanToStart() {
    const { t } = useTranslation();
    const { oneShop } = useSnapshot(userStore);
    const selectedAccount = useSelector(
        (state: RootState) => state.global.selectedAccount
    );
    return (
        <React.Fragment>
            <PageTitle title={"Applications"} />
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 1 }}
                className="page-content__clz home-page-content__clz"
            >
                <StyledBreadcrumb
                    items={[
                        {
                            item: "Settings".toUpperCase(),
                            link: `${process.env.REACT_APP_PORTAIL_URL}`,
                        },
                        {
                            item: selectedAccount?.toUpperCase() || "",
                            link: oneShop
                                ? "/setting/customer-account"
                                : "/compte",
                        },
                        {
                            item: t("Application").toUpperCase(),
                            link: "applications",
                        },
                        {
                            item: t("Scan to Start").toUpperCase(),
                            link: "#",
                        },
                    ]}
                />
                <div className="row p-4">
                    {CARD_MENU_LIST.map((cardMenu: any, index: any) => {
                        return (
                            <CardMenu
                                key={index}
                                title={t(cardMenu.title).toUpperCase()}
                                Icon={cardMenu.Icon}
                                description={t(cardMenu.description)}
                                path={cardMenu.path}
                            />
                        );
                    })}
                </div>
            </motion.div>
        </React.Fragment>
    );
}
